export enum MultiselectMode {
    SINGLE = 'single',
    MULTIPLE = 'tags',
    TAGS = 'tags',
}
